import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "../../../CommonCSS/SocietyCSS.css";
import { exportCAExcel } from "./ExportCAExcel";

const ChartOfAccount = () => {
  const [data, setData] = useState([]);
  const [structuredData, setStructuredData] = useState([]);
  const [groupedData, setGroupedData] = useState([]); /// just to match excel groupedData

  const [expandedMain, setExpandedMain] = useState({});
  const [expandedGroup, setExpandedGroup] = useState({});
  const [expandedSub, setExpandedSub] = useState({});
  const [societyName, setSocietyName] = useState();
  
  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/rpt_ChartOfAccount`);
      if (res.data.length > 0) {
        setData(res.data);
        setStructuredData(groupData(res.data));
        setGroupedData(groupData(res.data));
        setSocietyName(res.data[0].scty_name);
      }
    } catch (e) {
      console.log("Error loading Chart of Account", e);
    }
  };

  // ----------------------------------------------------------
  // GROUPING LOGIC (Main → Group → Sub-Group → Ledger)
  // ----------------------------------------------------------
  const groupData = (rows) => {
    const out = [];
    let currentMain = null;
    let currentGroup = null;
    let currentSub = null;

    rows.forEach((row) => {
      // Main Group
      if (currentMain !== row.main_grp_desc) {
        currentMain = row.main_grp_desc;
        currentGroup = null;
        currentSub = null;

        out.push({
          type: "main",
          key: currentMain,
          label: row.main_grp_desc
        });
      }

      // Group
      if (currentGroup !== row.grp_desc) {
        currentGroup = row.grp_desc;
        currentSub = null;

        out.push({
          type: "group",
          key: currentMain + "-" + currentGroup,
          mainKey: currentMain,
          label: row.grp_desc
        });
      }

      // Sub-Group (may be null)
      if (row.sub_grp_desc && currentSub !== row.sub_grp_desc) {
        currentSub = row.sub_grp_desc;

        out.push({
          type: "sub",
          key: currentMain + "-" + currentGroup + "-" + currentSub,
          groupKey: currentMain + "-" + currentGroup,
          label: row.sub_grp_desc
        });
      }

      // Ledger Row
      out.push({
        type: "ledger",
        parentKey: row.sub_grp_desc
          ? currentMain + "-" + currentGroup + "-" + currentSub
          : currentMain + "-" + currentGroup,
        acct_name: row.acct_name,
        acct_code: row.acct_code,
        status: row.status
      });
    });

    return out;
  };

  // ----------------------------------------------------------
  // Toggle handlers
  // ----------------------------------------------------------
  // const toggleMain = (key) => {
  //   setExpandedMain((p) => ({ ...p, [key]: !p[key] }));
  // };

  const toggleMain = (key) => {
    setExpandedMain(prev => {
      const isClosing = prev[key] === true;

      const newState = {
        ...prev,
        [key]: !prev[key],
      };

      if (isClosing) {
        // 1️⃣ Collapse all child groups
        setExpandedGroup(old => {
          const updated = { ...old };
          Object.keys(updated).forEach(gk => {
            if (gk.startsWith(key + "-")) delete updated[gk];
          });
          return updated;
        });

        // 2️⃣ Collapse all child sub-groups
        setExpandedSub(old => {
          const updated = { ...old };
          Object.keys(updated).forEach(sk => {
            if (sk.startsWith(key + "-")) delete updated[sk];
          });
          return updated;
        });
      }

      return newState;
    });
  };

  const toggleGroup = (key) => {
    setExpandedGroup((p) => ({ ...p, [key]: !p[key] }));
  };

  const toggleSub = (key) => {
    setExpandedSub((p) => ({ ...p, [key]: !p[key] }));
  };

  // ----------------------------------------------------------

  return (
    <Container fluid className="p-3 ">
      <Card className="mb-3 p-3">
        <Row>
          <Col className="text-end">
            <Button className="me-2" variant="success" onClick={loadData}>Refresh</Button>
            <Button className="me-2" variant="secondary" onClick={() => exportCAExcel({ groupedData, societyName })}
                           disabled={groupedData.length === 0}>Excel file</Button>
          </Col>
        </Row>
      </Card>

      <Card className="p-3">
        <div style={{ minHeight: '220px' }} className="table-responsive">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table-rcpt hover-table-rcpt">
          {/* className="table table-hover table-bordered" */}
            {/* "responsive-table scty-custom-table-rcpt hover-table-rcpt" */}
            <thead className="table-light">
              <tr>
                <th style={{ width: "80%" }}>Description</th>
                {/* <th style={{ width: "20%" }}>Account Code</th> */}
                <th style={{ width: "20%" }}>Account Status</th>
              </tr>
            </thead>

            <tbody>
              {structuredData.map((row, idx) => {

                // MAIN GROUP
                if (row.type === "main") {
                  return (
                    <tr key={idx}
                      style={{ background: "#CCCCFF", fontWeight: "bold", cursor: "pointer" }}
                      // D6D4F2
                      onClick={() => toggleMain(row.key)}
                    >
                      <td colSpan={3}>
                        <span className={`rotate-arrow ${expandedMain[row.key] ? "expanded" : ""}`}>
                          ▶
                        </span>{" "}
                        {row.label}
                      </td>
                    </tr>
                  );
                }

                // GROUP
                if (row.type === "group") {
                  if (!expandedMain[row.mainKey]) return null;

                  return (
                    <tr key={idx}
                      style={{ background: "#D8BFD8", fontWeight: "bold", cursor: "pointer" }}
                      //E8E8FF
                      onClick={() => toggleGroup(row.key)}
                    >
                      <td colSpan={2}>
                        <span style={{ paddingLeft: 25 }}>
                          <span className={`rotate-arrow ${expandedGroup[row.key] ? "expanded" : ""}`}>
                            ▶
                          </span>{" "}
                          {row.label}
                        </span>
                      </td>
                    </tr>
                  );
                }

                // SUB-GROUP
                if (row.type === "sub") {
                  if (!expandedGroup[row.groupKey]) return null;

                  return (
                    <tr key={idx}
                      style={{ background: "#F5F5FF", cursor: "pointer" }}
                      onClick={() => toggleSub(row.key)}
                    >
                      <td colSpan={2}>
                        <span style={{ paddingLeft: 50 }}>
                          <span className={`rotate-arrow ${expandedSub[row.key] ? "expanded" : ""}`}>
                            ▶
                          </span>{" "}
                          {row.label}
                        </span>
                      </td>
                    </tr>
                  );
                }

                // LEDGER ROW
                // if (row.type === "ledger") {
                //   if (!expandedGroup[row.parentKey.split("-").slice(0, 2).join("-")]) return null;

                //   // If ledger belongs to a sub-group
                //   //if (expandedSub[row.parentKey] === false) return null;
                //   if (!expandedSub[row.parentKey]) return null;

                //   return (
                //     <tr key={idx}>
                //       <td>
                //         <span style={{ paddingLeft: row.parentKey.split("-").length === 2 ? 75 : 75 }}>
                //           {row.acct_name}
                //         </span>
                //       </td>
                //       {/* <td>{row.acct_code}</td> */}
                //       <td>{row.status}</td>
                //     </tr>
                //   );
                // }

                if (row.type === "ledger") {
                  const groupKey = row.parentKey.split("-").slice(0, 2).join("-");

                  // Ledger only shown if GROUP is expanded
                  if (!expandedGroup[groupKey]) return null;

                  // Ledger of a sub-group ← only show when sub is expanded
                  if (row.parentKey.split("-").length === 3) {
                    if (!expandedSub[row.parentKey]) return null;
                  }

                  return (
                    <tr key={idx}>
                      <td>
                        <span style={{ paddingLeft: 75 }}>
                          {row.acct_name}
                        </span>
                      </td>
                      {/* <td>{row.acct_code}</td> */}
                      <td>{row.status}</td>
                    </tr>
                  );
                }

                return null;
              })}
            </tbody>
          </table>
        </div>
      </Card>
    </Container>
  );
};

export default ChartOfAccount;
